import { getFullUrl } from 'hubspot-url-utils';
import { isQa } from '../utils/env';
export const FeatureSrcMap = {
  'meeting-scheduler-unboxing': `${getFullUrl('app', {
    envOverride: isQa() ? 'qa' : 'prod'
  })}/meetings-scheduler-unboxing/overview`,
  'livechat-unboxing': `${getFullUrl('app', {
    envOverride: isQa() ? 'qa' : 'prod'
  })}/livechat-unboxing`
};